/**
 * Fetch a single interview by ID.
 * GET /api_ats/v1/ats_interviews/:id
 */
import { useQuery } from '@tanstack/react-query';
import { http } from '@/lib/ats-https';
import { asAtsClientBody, unwrapAtsEnvelope } from '@/api/ats/atsEnvelope';
import type { InterviewDetails } from './interviews.types';

export async function fetchInterview(
  interviewId: number
): Promise<InterviewDetails> {
  const raw = asAtsClientBody<unknown>(
    await http.get(`/ats_interviews/${interviewId}`)
  );
  return unwrapAtsEnvelope<InterviewDetails>(raw);
}

export function useGetInterview(
  interviewId: number | undefined,
  options?: { enabled?: boolean }
) {
  return useQuery<InterviewDetails, Error>({
    queryKey: ['schedule-interview', 'detail', interviewId],
    queryFn: () => fetchInterview(interviewId!),
    enabled: (options?.enabled ?? true) && interviewId !== undefined,
    staleTime: 60_000,
  });
}
